import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import { get, isEmpty } from 'lodash';
export default {
  name: 'CoreDeviceTemplateEditDeviceInformation',
  mixins: [iconsMixin],
  props: {
    template: {
      type: Object,
      required: true
    },
    account: {
      type: String,
      default: null
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function () {
    return {
      formValid: false,
      deviceBridgesForAccount: [],
      bridgeTypes: [],
      deviceBridgesLoading: false,
      selectedBridge: null,
      notEditableConnectorFields: [],
      allConnectorFieldsSet: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    scopeDetailedName() {
      const name = get(this.template, 'scope.name');
      const id = get(this.template, 'scope.id') || get(this.template, 'scopeId');
      if (id !== undefined) {
        return `${name} (ID ${id})`;
      }
      return name;
    },
    bridgeCreateParameters() {
      const createDeviceMethod = get(this.bridgeConfig(this.selectedBridge), 'manifest.functionScope.extension.devices.create');
      return get(this.bridgeConfig(this.selectedBridge), `manifest.commands.instance.${createDeviceMethod}.parameters.data.properties`) || {};
    },
    bridgeCreateFields() {
      const createParameters = this.bridgeCreateParameters || {};
      let keys = Object.keys(createParameters).filter(k => {
        return createParameters[k].predefineInTemplates;
      });
      return keys.sort((a, b) => {
        const orderIdxA = get(createParameters, `[${a}].orderIdx`) || 0;
        const orderIdxB = get(createParameters, `[${b}].orderIdx`) || 0;
        if (orderIdxA < orderIdxB) {
          return -1;
        }
        if (orderIdxA > orderIdxB) {
          return 1;
        }
        return a.localeCompare(b);
      });
    }
  },
  watch: {
    'template.tenantId'() {
      this.fetchBridges();
    },
    template: {
      handler() {
        if (!this.template) {
          return;
        }
        this.$emit('formValidated', this.formValid);
      },
      deep: true
    },
    formValid() {
      this.$emit('formValidated', this.formValid);
    },
    selectedBridge() {
      if (!this.selectedBridge) {
        return;
      }
      this.setFieldsAndStatus();
    }
  },
  methods: {
    get,
    isEmpty,
    parentSelectorFilter(item, parentList) {
      if (!this.template) {
        return;
      }
      return item.tenantId === this.template.tenantId && item.id !== this.template.id && parentList.findIndex(t => t.id === this.template.id) === -1;
    },
    setTags(tags) {
      this.template.deviceMeta.tags = tags;
    },
    setGroups(a) {
      this.template.deviceMeta.groups = a.groups;
    },
    restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    },
    fetchBridges() {
      this.selectedBridge = null;
      this.deviceBridgesForAccount = [];
      if (!this.template || !this.template.tenantId) {
        return;
      }
      this.deviceBridgesLoading = true;
      Promise.all([ApiService.getBridgeTypes().then(bridgeTypes => {
        return bridgeTypes.filter(type => {
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }), ApiService.getBridgesForTenant(this.template.tenantId)]).then(results => {
        this.bridgeTypes = results[0];
        let validDeviceBridges = results[1].filter(bridgeInstance => {
          const bridgeTypeDef = results[0].find(bridgeDef => bridgeDef.type === bridgeInstance.type);
          if (get(bridgeTypeDef, 'manifest.functionScope.extension.devices.create') || get(bridgeTypeDef, 'manifest.functionScope.extension.devices.read')) {
            return true;
          }
          return false;
        });
        this.deviceBridgesForAccount = validDeviceBridges;
        this.selectedBridge = validDeviceBridges.find(bridge => bridge.id === this.template.deviceMeta.connectorId);
        this.deviceBridgesLoading = false;
      }).catch(error => {
        this.deviceBridgesLoading = false;
        this.$snack(this.$i18n_t('Connectors.Connectors.errors.connectionError'), 'error');
        console.error('Error fetching bridges', error);
      });
    },
    bridgeConfig(bridge) {
      if (!bridge) {
        return;
      }
      const foundMatch = this.bridgeTypes.find(config => {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    setFieldsAndStatus() {
      const bridgeConfig = this.bridgeConfig(this.selectedBridge);
      if (!bridgeConfig) {
        console.warn('Bridge configuration is not available.');
        return;
      }
      const createDeviceMethod = get(bridgeConfig, 'manifest.functionScope.extension.devices.create', null);
      const createParameters = get(bridgeConfig, `manifest.commands.instance.${createDeviceMethod}.parameters.data.properties`, {});
      this.notEditableConnectorFields = [];
      this.allConnectorFieldsSet = true;
      Object.keys(createParameters).forEach(key => {
        const param = createParameters[key];

        // Identify non-editable fields
        if (param.visible) {
          this.notEditableConnectorFields.push(Object.keys(param.visible)[0]);
        } else if (param.disableUpdate) {
          this.notEditableConnectorFields.push(key);
        }

        // Check if all connector fields are set
        if (param.predefineInTemplates && !param.optional && !this.template.deviceMeta.connectorData[key]) {
          this.allConnectorFieldsSet = false;
        }
      });
    },
    getDependsOnFieldValue(createFields, currentField, deviceData) {
      const dependsOnFieldName = get(createFields[currentField], 'dependsOnField');
      if (!dependsOnFieldName) {
        return null;
      }
      return deviceData[dependsOnFieldName];
    }
  }
};